(function () {
  var current = location.pathname;
  if (current === "") return;
  var menuItems = document.querySelectorAll('.blog-tagged-links a');
  for (var i = 0, len = menuItems.length; i < len; i++) {
      if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
          menuItems[i].className += "active";
      }
  }
})();